<template>
  <div
    class="px-3 py-2 d-flex"
    style="height: 90px; bottom: 0; background-color: #f9fafb">
    <div>
      
    </div>
    <img
      :src="data.thumb"
      class="rounded-2 me-2"
      style="object-fit: cover" />
    <div class="text-normal text-break flex-1">
      <div
        style="white-space: normal"
        class="fw-semibold font-size-14 text-1-line">
        {{ data.title }}
      </div>
      <div
        style="white-space: normal"
        class="text-1-line font-size-13">
        {{ data.desc }}
      </div>
      <a class="fw-semibold font-size-13">{{ data.src }}</a>
    </div>
    <div style="">
      <img
        :src="hovered === 1 ? iconCloseFill : iconClose"
        @mouseover="hovered = 1"
        @mouseleave="hovered = null"
        @click="closeReplied()"
        class="pointer"
        style="width: 15px; height: 15px; right: 6px"
        alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkPopup",
  props: {
    data: Object,
  },
  data() {
    return {
      hovered: null,
      iconClose: "/assets/icon/icon_close.svg",
      iconCloseFill: "/assets/icon/icon_close_fill.svg",
    };
  },
  methods: {
    closeReplied() {
      this.$emit("closeLinkPopup");
    },
  },
};
</script>

<style scoped>
</style>